import React, { createContext, useState, useContext, useEffect } from 'react';

const WorkspaceContext = createContext();

export const WorkspaceProvider = ({ children }) => {
  const [workspaceId, setWorkspaceId] = useState(null);
  const [isWorkspaceLoading, setIsWorkspaceLoading] = useState(true); // Add loading state

  // Function to set the workspace ID (used after fetching or selection)
  const updateWorkspaceId = (newWorkspaceId) => {
    if (newWorkspaceId) {
      setWorkspaceId(newWorkspaceId);
      localStorage.setItem('workspaceId', newWorkspaceId);
  } else {
      localStorage.removeItem('workspaceId');
  }
  };
          
  useEffect(() => {
    const storedWorkspaceId = localStorage.getItem('workspaceId');
    if (storedWorkspaceId) {
      setWorkspaceId(storedWorkspaceId);
    }
    setIsWorkspaceLoading(false); // Set loading to false when component mounted
  }, []);

  const value = {
    workspaceId,
    updateWorkspaceId,
    isWorkspaceLoading
  };

  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export const useWorkspace = () => {
  return useContext(WorkspaceContext);
};